'use strict'

const AccessAction = require('../action')
const Logger = require('@gsm/logger')
const mapping = require('./activity-mapping.json')
const Q = require('q')
const Util = require('../common/util')

Object.keys(mapping).forEach(featureServiceName => {
    const featureService = mapping[featureServiceName]
    Object.keys(featureService).forEach(featureActivityName => {
        const featureActivity = featureService[featureActivityName]
        featureService[featureActivityName] = featureActivity.map(accessAction => {
            const action = Util.parseAction(accessAction)
            return AccessAction[action.service][action.activity]
        })
    })
})

const forFeatureActions = (featureActions) => {
    return Q(featureActions.reduce((actions, featureAction) => {
        const { activity, service } = featureAction
        const actionList = []
        if (Util.Wildcard === activity) {
            Object.keys(mapping[service]).forEach(a => {
                actionList.push.apply(actionList, mapping[service][a])
            })
        }
        else {
            const a = mapping[service][activity] || []
            actionList.push.apply(actionList, a)
        }
        if (!actionList.length) {
            const s = JSON.stringify(featureAction)
            Logger.warn(`No mapping from feature action to access: ${s}`)
        }
        actions.push.apply(actions, actionList || [])
        return actions
    }, []))
}

module.exports = {
    forFeatureActions
}



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/feature-policy/access-policy-actions.js
// module id = 295
// module chunks = 51